import { useState, useEffect } from "react";
import swal from "sweetalert2";
import {
  getCashCardBalanceData,
  getCashCardBalances,
  getCashCardReportData,
} from "../api/reportsAPI";
import moment from "moment";

const CashCardReport = (props) => {
  const [isInit, setIsInit] = useState(true);
  const [cashCardReport, setCashCardReport] = useState(null);
  const [bookingTable, setBookingTable] = useState(null);

  // const balanceCache = new Map();

  useEffect(() => {
    props.title("Cash Card Report", "cash-card-report");
    fetchCards();
    fillTable();
  }, []);

  useEffect(() => {
    if (!isInit && cashCardReport) {
      fillTable();
    }
  }, [cashCardReport]);

  const fetchCards = async () => {
    try {
      swal.fire({
        titleText: "Loading",
        text: "Please Wait. .. ",
        showConfirmButton: false,
        onOpen: () => swal.showLoading(),
      });

      const response = await getCashCardReportData();
      const cardReportData = response?.BookSheet;

      isInit ? setIsInit(false) : $("#tblCashCardReport").KTDatatable().destroy();
     
      setCashCardReport( cardReportData.map(c => ({ ...c, CardAmt: "Processing..." })) );

    } catch (err) {
      console.error("Error fetching data:", err);
      swal.fire({
        icon: "error",
        titleText: err.message,
      });
    }
  };

  /**@description - previously Used for fetching all card balance - 1 card = 1 request */
	// const fetchBalancesForVisibleRows = async (rows) => {
	// 	if(!rows) return;
	
	// 	const calls = rows.map(async (row) => {
	// 		// if (balanceCache.has(row.CardNumber)) return;
	// 		try {
	// 			const { BookSheet } = await getCashCardBalanceData(row?.CardNumber);
	// 			// balanceCache.set(row?.CardNumber, BookSheet?.CardAmt);
	// 			updateBalanceInTable(row?.CardNumber, BookSheet?.CardAmt);
	// 		} catch (err) {
	// 			console.error("Error:", row?.CardNumber);
	// 			updateBalanceInTable(row?.CardNumber, "Error");
	// 		}
	// 	});
	// 	await Promise.allSettled(calls);
	// };


	const fetchCardsBalance = async(rows)=>{
		try {
			if(!rows) return;

			const { cardSheet } = await getCashCardBalances(rows);		

			if(cardSheet && cardSheet?.length > 0){				
				for( const card of cardSheet){					
					updateBalanceInTable(card?.CardNo, card?.CardAmt)
				}
			}

		} catch (err) {
			console.error("failed to fetch cashcard balances:", err.message);
		}
	}

	const updateBalanceInTable = (cardNumber, amount) => {	
		$(`[data-cardno="${cardNumber}"]`).text(`₹ ${amount}`);
	};

	const getVisibleRowsFromDOM = () => {
		const rows = [];

		$("#tblCashCardReport tbody tr").each(function () {
			const row = $(this);
			const cardNumber = row.find("[data-cardno]").data("cardno");

			if (cardNumber) {
				rows.push({
					CardNumber: cardNumber,
				});
			}
		});

		return rows;
	};

  function fillTable() {
    swal.close();

    const $table = $("#tblCashCardReport");
    if ($table.data("KTDatatable")) {
      $table.KTDatatable().destroy();
    }

    const tblBookSheet = $("#tblCashCardReport").KTDatatable({
      data: {
        saveState: false,
        source: cashCardReport,
      },
      layout: {
        scroll: false,
        footer: false,
      },
      sortable: false,
      // ── PAGINATION ──────────────────────────────────────────
      pagination: true,
      pageSize: 10,           // rows shown per page
      pageSizeSelect: [10], // page-size dropdown options
      // ────────────────────────────────────────────────────────
      search: {
        input: $("#generalSearch"),
      },
      columns: [
        { title: "Membership No", field: "MembershipNo", width: 120 },
        { title: "Name", field: "UserName", width: 120 },
        { title: "Member Type", field: "MemberType", width: 100,
					template:function(row){
						const memberTypeClass = (row.MemberType == "Child")? 'secondary' : ((row.MemberType == "Spouse") ? 'success' : ((row.MemberType == "Dependent") ? 'info' : 'primary'));
						return `<span class="kt-badge kt-badge--${memberTypeClass} kt-badge--pill padding-lr30 padding-tb12"> ${row.MemberType} </span>`;
					},
				},
        {
          field: 'MembershipExpiresOn',
          title: 'Mem. Expiry',
          width: 80,
          template: (row) => moment(row.MembershipExpiresOn).format("DD-MM-YYYY")
        },
        { title: "Card Number", field: "CardNumber", width: 120 },
        {
          title: "Card Balance",
          field: "CardAmt",
          width: 120,
          template: function (row) {
						return `<span data-cardno="${row.CardNumber}" style="display:inline-block; min-width:100px; text-align:left;">
							₹ ${row?.CardAmt || "Processing..."}
						</span>`;
					},
        },
      ],
      rows: {
        autoHide: false,
      },
    });

		tblBookSheet.on("kt-datatable--on-layout-updated", function () {					
			const visibleRows = getVisibleRowsFromDOM();

			if (visibleRows.length > 0) {			
				// fetchBalancesForVisibleRows(visibleRows);
				fetchCardsBalance(visibleRows);
			}
		});

    $("#root .kt-grid--hor").addClass("max-width100");
    $("#tblBookSheet .kt-datatable__table").addClass("overflow-x-auto");

    Config.Core.InitPopover();
    Config.Core.GrabAndScroll(".kt-datatable__table");

    const fileName = `${moment().format("DD-MM-YYYY")} - Cash Card Report`;

    const BookingTable = $(".kt-datatable__table").tableExport({
      formats: ["xlsx", "csv"],
      headers: true,
      filename: fileName,
    });

    setBookingTable(BookingTable);
    
		$(".tableexport-caption").addClass("hidden");			
  }

  function exportSheet(type) {
    const fileName = `${moment().format("DD-MM-YYYY")} - Member Cash Card Report`;

    bookingTable.update({
      headers: true,
      formats: ["xlsx", "csv"],
      filename: fileName,
    });

    if (type == "xlsx") {
      $(".button-default.xlsx").click();
    } else {
      $(".button-default.csv").click();
    }
    $(".tableexport-caption").addClass("hidden");
  }

  return (
    <>
      <div
        className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0"
        id="kt_content"
      >
        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
          <div className="kt-portlet">
            <div className="kt-portlet__body padding-t20 padding-b0">
              <div
                id="ControlHolder"
                className="kt-form kt-form--label-right padding-10"
                role="form"
              >
                <div className="row d-flex justify-content-end">
                  <div className="form-group col-sm-2">
                    <div className="input-group">
                      <div className="kt-input-icon kt-input-icon--left">
                        <input
                          type="text"
                          className="form-control clientSearch"
                          placeholder="Search..."
                          id="generalSearch"
                        />
                        <span className="kt-input-icon__icon kt-input-icon__icon--left">
                          <span>
                            <i className="la la-search"></i>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-1">
                    <div className="dropdown">
                      <button
                        className="btn btn-label-brand dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Export
                      </button>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                        x-placement="bottom-start"
                        style={{
                          position: "absolute",
                          willChange: "transform",
                          top: "0px",
                          left: "0px",
                          transform: "translate3d(0px, 38px, 0px)",
                        }}
                      >
                        <button
                          id="btn-export-excel"
                          type="button"
                          className="dropdown-item"
                          onClick={() => exportSheet("xlsx")}
                        >
                          {" "}
                          Excel
                        </button>
                        <button
                          id="btn-export-csv"
                          type="button"
                          className="dropdown-item"
                          onClick={() => exportSheet("csv")}
                        >
                          {" "}
                          Csv{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="tblCashCardReport"
                className="table table-bordered table-hover custom-datatable"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CashCardReport;